import { Group } from '@mantine/core';
import { useGlobalStore } from '../../store/global-store/global-store';
import { H2 } from '../../ui-library/typography/typography';
import { MenuDrivenContainer } from '../menu-driven-container/menu-driven-container';
import { FloraAside } from './flora';

export const FloraPage = () => {
  const { useAI } = useGlobalStore();
  const header = (
    <Group>
      <H2>Flora</H2>
    </Group>
  );
  return <MenuDrivenContainer header={header}>{useAI && <FloraAside />}</MenuDrivenContainer>;
};
